// extracted by mini-css-extract-plugin
module.exports = {"formCard":"styles_formCard__3YJfz"};